import { COMPONENT_VALUE_TYPES as types, REGIONS, ENV_DOMAINS } from 'shared/constants';

const propsSchema = [
  {
    key: 'version',
    label: 'Version',
    tooltip: 'The version 2 will apply the style that is predefined by the global design system',
    type: types.ENUM,
    options: [1, 2, 3, 4]
  },
  {
    key: 'footerRegion',
    label: 'Footer Region',
    type: types.ENUM,
    options: REGIONS
  },
  {
    key: 'items',
    label: 'Footer Items',
    type: types.ARRAY,
    option: false,
    children: [
      {
        key: 'sectionTitle',
        label: 'Section Title',
        type: types.TEXT
      },
      {
        key: 'links',
        label: 'Links',
        type: types.ARRAY,
        options: false,
        children: [
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT
          },
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT
          }
        ]
      },
    ]
  },
  {
    key: 'socialLinks',
    label: 'Social Links',
    type: types.ARRAY,
    option: false,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT
      },
      {
        key: 'icon',
        label: 'Icon',
        type: types.ICON
      }
    ]
  },
  {
    key: 'regions',
    label: 'Region Selector',
    type: types.ARRAY,
    enum: false,
    children: [
      {
        key: 'imgUrl',
        label: 'Region',
        type: types.TEXT
      },
      {
        key: 'value',
        label: 'Value',
        type: types.ENUM,
        options: REGIONS
      },
      {
        key: 'domain',
        label: 'Domain',
        type: types.ENUM,
        options: ENV_DOMAINS
      }
    ]
  },
  {
    key: 'copyright',
    label: 'Copyright Text',
    type: types.OBJECT,
    children: [
      {
        key: 'text',
        label: 'Plain Text',
        type: types.TEXT
      },
      {
        key: 'link_url',
        label: 'Additional Link Url',
        type: types.TEXT
      },
      {
        key: 'link_text',
        label: 'Additional Link Text',
        type: types.TEXT
      },
      {
        key: 'icon_url',
        label: 'Icon Url',
        type: types.TEXT
      },
      {
        key: 'show_horizontal_alignment',
        label: 'Show Horizontal Alignment',
        type: types.BOOLEAN
      },
      {
        key: 'moreLinks',
        label: 'More Links',
        type: types.ARRAY,
        children: [
          {
            key: 'url',
            label: 'Link Url',
            type: types.TEXT
          },
          {
            key: 'text',
            label: 'Link Text',
            type: types.TEXT
          },
          {
            key: 'icon_url',
            label: 'Icon Url',
            type: types.TEXT
          }
        ]
      },
    ]
  },
  {
    key: 'download',
    label: 'App Store Settings',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'appButtonText',
        label: 'App Button Text',
        type: types.TEXT,
      },
      {
        key: 'iosStoreLink',
        label: 'iOS Store link',
        type: types.TEXT,
      },
      {
        key: 'iosAppLink',
        label: 'iOS App link',
        type: types.TEXT,
      },
      {
        key: 'iosImage',
        label: 'iOS store Image',
        type: types.TEXT,
      },
      {
        key: 'androidStoreLink',
        label: 'Android Store Link',
        type: types.TEXT,
      },
      {
        key: 'androidAppLink',
        label: 'Android App Link',
        type: types.TEXT,
      },
      {
        key: 'androidApkLink',
        label: 'Android Apk Link',
        type: types.TEXT,
      },
      {
        key: 'androidImage',
        label: 'Android Store Image',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'subscribeForm',
    label: 'Subscribe Form',
    type: types.OBJECT,
    children: [
      {
        key: 'enabled',
        label: 'Enabled',
        type: types.BOOLEAN,
      },
      {
        key: 'submitUrl',
        label: 'Submit url',
        type: types.TEXT,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
      {
        key: 'inputPlaceholder',
        label: 'Input Placeholder',
        type: types.TEXT,
      },
      {
        key: 'inputErrorMessage',
        label: 'Input Error Message',
        type: types.TEXT,
      },
      {
        key: 'serverErrorMessage',
        label: 'Server Error Message',
        type: types.TEXT,
      },
      {
        key: 'successMessage',
        label: 'Success Message',
        type: types.TEXT,
      },
      {
        key: 'button',
        label: 'Button Text',
        type: types.TEXT,
      },
      {
        key: 'margin',
        label: 'Form Margin',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'navLinks',
    label: 'Navigation Links (v4)',
    type: types.ARRAY,
    children: [
      {
        key: 'links',
        label: 'Links',
        type: types.ARRAY,
        children: [
          {
            key: 'text',
            label: 'Text',
            type: types.TEXT,
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
          {
            key: 'prompt',
            label: 'Prompt',
            type: types.OBJECT,
            children: [
              {
                key: 'title',
                label: 'Title',
                type: types.TEXT,
              },
              {
                key: 'message',
                label: 'Message',
                type: types.TEXT,
              },
              {
                key: 'actionText',
                label: 'Action Button Text',
                type: types.TEXT,
              },
              {
                key: 'cancelText',
                label: 'Cancel Button Text',
                type: types.TEXT,
              },
            ],
          },
        ]
      },
    ]
  },
  {
    key: 'extraLinks',
    label: 'Extra Links (v4)',
    type: types.ARRAY,
    children: [
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'regionsV4',
    label: 'Regions (v4)',
    type: types.ARRAY,
    children: [
      {
        key: 'code',
        label: 'Code',
        type: types.ENUM,
        options: REGIONS
      },
      {
        key: 'url',
        label: 'URL',
        type: types.ENUM,
        options: ENV_DOMAINS
      },
      {
        key: 'country',
        label: 'Country',
        type: types.TEXT,
      },
      {
        key: 'language',
        label: 'Language',
        type: types.TEXT,
      }
    ]
  },
  {
    key: 'disclaimerText',
    label: 'Disclaimer Text (v4)',
    tooltip: 'Large disclaimer text displayed below navigation links and above social icons',
    type: types.TEXTAREA,
    options: {
      rows: 6,
    }
  },
  {
    key: 'withFloatingCTA',
    label: 'Add padding for floating CTA (v4)',
    type: types.BOOLEAN
  },
];

const defaultProps = {
  footerRegion: 'US',
  regions: [
    { imgUrl: 'https://genesis-cdn.ff.com/icon-en.png', value: 'US', domain: '' },
    { imgUrl: 'https://genesis-cdn.ff.com/icon-china.png', value: 'CN', domain: '' }
  ],
  items: [
    {
      sectionTitle: 'ABOUT US',
      links: [
        { url: '/our-company', label: 'Our Company' },
        { url: '/our-approach', label: 'Our Approach' },
        { url: '/our-team', label: 'Our Team' },
        { url: '/press-room', label: 'Press Room' },
        { url: '/futuresight', label: 'Blog' },
        { url: '/ff-zero-1', label: 'FF Zero 1' },
        { url: '/gallery', label: 'FF Gallery' },
        { url: '/solutions', label: 'Solutions' },
        { url: 'https://investors.ff.com', label: 'Investors' },
      ]
    },
    {
      sectionTitle: 'SUPPORT',
      links: [
        { url: '/contact-us', label: 'Contact Us' },
        { url: '/frequently-asked-questions', label: 'FAQ' },
        { url: '/careers', label: 'Careers' },
        { url: '/sitemap', label: 'Sitemap' },
        { url: '/privacy-policy', label: 'Privacy Policy' },
        { url: '/terms-of-use', label: 'Terms of Use' },
      ]
    }
  ],
  socialLinks: [
    { url: 'https://linkedin.com', icon: 'ff-icon-social-linkedin' },
    { url: 'https://youtube.com', icon: 'ff-icon-social-youtube' },
    { url: 'https://twitter.com', icon: 'ff-icon-social-twitter' },
    { url: 'https://facebook.com', icon: 'ff-icon-social-facebook' },
    { url: 'https://instagram.com', icon: 'ff-icon-social-instagram' }
  ],
  copyright: {
    text: 'Faraday&Future Inc. The Faraday Future name and logo are trademarks of Faraday&Future Inc. All rights reserved.'
  },
  download: {
    url: 'https://www.ff.com/us/mobile-app',
    title: 'DOWNLOAD FF INTELLIGENT APP',
    appButtonText: 'INSTALL APP',
    iosStoreLink: 'https://itunes.apple.com/us/app/id1600637235?ls=1&mt=8',
    iosAppLink: 'https://faradayfuture2023.app.link/YajHk0j7Nxb',
    iosImage: '',
    androidStoreLink: 'https://play.google.com/store/apps/details?id=com.faradayfuture.online.foreign',
    androidAppLink: 'faradayfuture://feed',
    androidApkLink: '',
    androidImage: ''
  },
  subscribeForm: {
    enabled: true,
    submitUrl: '/api/subscribe/',
    title: 'Get the latest news and important updates from FF',
    subtitle: 'Sign up for the latest of the FF 91 Futurist and other news about Faraday Future',
    inputPlaceholder: 'Email*',
    inputErrorMessage: 'Please provider a valid email',
    serverErrorMessage: 'Something went wrong. Please try again later.',
    successMessage: 'Your subscription has been confirmed. You’ll receive the latest news and updates from Faraday Future.',
    button: 'Subscribe →',
    margin: '10px 0px',
  },
  navLinks: [
    {
      links: [
        { text: 'FF 91 Futurist Alliance', url: '/us/product/ff-91-Alliance/' },
        { text: 'FF 91 Futurist ', url: '/us/product/ff-91-Futurist/' },
        { text: 'FF 91 ', url: '/us/design/2022/FF91/model' },
        { text: 'Ecosystem Services ', url: '/' },
      ]
    },
    {
      links: [
        { text: 'Live', url: '/' },
        { text: 'Press Room', url: '/us/press-room/' },
        { text: 'Investor Relations', url: 'https://investors.ff.com/' },
      ]
    },
    {
      links: [
        { text: 'Charging', url: '/us/charging/' },
        { text: 'Service', url: '/us/service/' },
        { text: `Owner's Manual`, url: '/' },
        { text: 'Find Us', url: '/us/find-us/' },
        { text: 'Contact Us', url: '/us/contact-us/' },
      ]
    },
    {
      links: [
        { text: 'My Account', url: '/us/MyFF' },
      ]
    },
  ],
  extraLinks: [
    {
      text: 'Privacy & Legal',
      url: '/us/privacy-policy/'
    },
    {
      text: 'About Us',
      url: '/us/our-company/'
    },
    {
      text: 'Our Team',
      url: '/us/our-team/'
    },
    {
      text: 'Careers',
      url: '/us/careers/'
    },
  ],
  regionsV4: [
    {
      country: 'United States',
      code: 'US',
      language: 'English',
      url: 'https://www.ff.com/us/'
    },
    {
      country: 'China',
      code: 'CN',
      language: '中文',
      url: 'https://www.faradayfuturecn.com/cn/'
    }
  ],
};

export default {
  title: 'Footer',
  id: 'Footer',
  propsSchema,
  defaultProps
};
